import { Button, Col, Divider, notification, Popconfirm, Row } from 'antd';
import { gatewayApi } from 'api/gatewayApi';
import { useAppSelector } from 'app/hooks';
import AddEditFormGateway from 'components/Common/Modal/AddEditFormGateway';
import { selectIsDisable } from 'features/Login/authSlice';
import { GatewayInfo } from 'models/gateway';
import moment from 'moment';
import * as React from 'react';
import { FiChevronLeft, FiEdit } from 'react-icons/fi';
import style from './GatewayInfo.module.scss';
import { selectGatewayInfo } from './gatewaySlice';
export interface GatewayInformationProps {
  isShowGatewayDetail: boolean;
  setIsShowGatewayDetail: (value: boolean) => void;
  setGatewayList: (value: GatewayInfo[]) => void;
}

export default function GatewayInformation({
  isShowGatewayDetail,
  setIsShowGatewayDetail,
  setGatewayList,
}: GatewayInformationProps) {
  const itemGateway = useAppSelector(selectGatewayInfo);
  const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false);
  // const [isEvent, setIsEvent] = React.useState<boolean>(true);
  const isEvent: boolean = true;
  const isDisable = useAppSelector(selectIsDisable);

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const onDeleteItemGateway = async (value: string) => {
    await gatewayApi.remove(value);
    const res = await gatewayApi.fetchGateways({ _limit: 5, _page: 0 });
    setGatewayList(res.data);
    openNotificationWithIcon('success', 'Delete gateway successfully');
    setIsShowGatewayDetail(!isShowGatewayDetail);
  };

  return itemGateway ? (
    <Row className={style.root}>
      <Row className={style.header_info}>
        <Col lg={16} xl={19} className={style.header_label_info}>
          {!isShowGatewayDetail && (
            <FiChevronLeft
              style={{ marginRight: '5px', cursor: 'pointer' }}
              onClick={() => setIsShowGatewayDetail(!isShowGatewayDetail)}
            />
          )}
          {itemGateway?.label}
        </Col>
        <Col lg={8} xl={5} className={style.header_group_btn}>
          <Popconfirm
            placement="bottomLeft"
            title="Sure to delete?"
            onConfirm={() => onDeleteItemGateway(itemGateway.id)}
          >
            <Button disabled={isDisable} className={style.btn_delete}>
              Delete
            </Button>
          </Popconfirm>
          {/* <Badge count={1}>
            <Button className={style.btn_config} onClick={() => setIsModalVisible(!isModalVisible)}>
              Config
              <FiSettings style={{ marginLeft: '10px' }} />
            </Button>
          </Badge> */}
          <Button
            disabled={isDisable}
            className={style.btn_edit}
            onClick={() => {
              setIsModalVisible(!isModalVisible);
            }}
          >
            Edit
            <FiEdit style={{ marginLeft: '10px' }} />
          </Button>
        </Col>
      </Row>
      <div className={style.main_detail} id={'style_4'}>
        <Divider orientation="left" plain style={{ fontWeight: 'bold' }}>
          General Info
        </Divider>
        <div className={style.content_plant_information}>
          <Col lg={8} xl={5} className={style.text_plant_information}>
            Code
          </Col>
          <Col lg={16} xl={19} className={style.values_plant_information}>
            {itemGateway?.code}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col lg={8} xl={5} className={style.text_plant_information}>
            Label
          </Col>
          <Col lg={16} xl={19} className={style.values_plant_information}>
            {itemGateway?.label}
          </Col>
        </div>
        {/* <div className={style.content_plant_information}>
          <Col lg={8} xl={5} className={style.text_plant_information}>
            Access Token
          </Col>
          <Col lg={16} xl={19} className={style.values_plant_information}>
            {itemGateway?.system_size === null ? 'N/A' : `${itemGateway?.system_size} kWp`}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col lg={8} xl={5} className={style.text_plant_information}>
            Created Time
          </Col>
          <Col lg={16} xl={19} className={style.values_plant_information}>
            {moment(itemGateway?.installation_date).format('DD-MM-YYYY THH:mm:ss')}
          </Col>
        </div> */}
        <div className={style.content_plant_information}>
          <Col lg={8} xl={5} className={style.text_plant_information}>
            Location
          </Col>
          <Col lg={16} xl={19} className={style.values_plant_information}>
            {itemGateway?.location ? `${itemGateway?.location}` : 'N/A'}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col lg={8} xl={5} className={style.text_plant_information}>
            Installtion Date
          </Col>
          <Col lg={16} xl={19} className={style.values_plant_information}>
            {moment(itemGateway?.installation_date).format('YYYY-MM-DD HH:mm:ss')}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col lg={8} xl={5} className={style.text_plant_information}>
            Model
          </Col>
          <Col lg={16} xl={19} className={style.values_plant_information}>
            {itemGateway?.model ? `${itemGateway?.model}` : 'N/A'}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col lg={8} xl={5} className={style.text_plant_information}>
            Serial Number
          </Col>
          <Col lg={16} xl={19} className={style.values_plant_information}>
            {itemGateway?.serial_number ? `${itemGateway?.serial_number}` : 'N/A'}
          </Col>
        </div>
        <Divider orientation="left" plain style={{ fontWeight: 'bold' }}>
          Connection Info
        </Divider>
        <div className={style.content_plant_information}>
          <Col lg={8} xl={5} className={style.text_plant_information}>
            Active
          </Col>
          <Col
            lg={16}
            xl={19}
            className={style.values_plant_information}
            style={{ color: '#2194FF' }}
          >
            {itemGateway.active ? 'True' : 'False'}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col lg={8} xl={5} className={style.text_plant_information}>
            Last activity time
          </Col>
          <Col lg={16} xl={19} className={style.values_plant_information}>
            {moment(itemGateway?.last_activity_time).format('YYYY-MM-DD HH:mm:ss')}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col lg={8} xl={5} className={style.text_plant_information}>
            Last connect time
          </Col>
          <Col lg={16} xl={19} className={style.values_plant_information}>
            {moment(itemGateway?.last_connect_time).format('YYYY-MM-DD HH:mm:ss')}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col lg={8} xl={5} className={style.text_plant_information}>
            Last disconnect time
          </Col>
          <Col lg={16} xl={19} className={style.values_plant_information}>
            {moment(itemGateway?.last_disconnect_time).format('YYYY-MM-DD HH:mm:ss')}
          </Col>
        </div>
      </div>
      <AddEditFormGateway
        isEvent={isEvent}
        itemGateway={itemGateway}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        setGatewayList={setGatewayList}
      />
    </Row>
  ) : null;
}
